import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from "vanilla-cookieconsent";

export const cookieConsent = CookieConsent;

CookieConsent.run({
  guiOptions: {
    consentModal: {
      position: 'bottom right',
    }
  },
  categories: {
    necessary: {
      enabled: true,
      readOnly: true
    },
    analytics: {
      enabled: false,
      readOnly: false,
      autoClear: {
        cookies: [
          {
            name: /^_ga/,   // regex: match all cookies starting with '_ga'
          },
          {
            name: '_gid',   // string: exact cookie name
          }
        ]
      },
      services: {
        googleAnalytics: {
          label: 'Google Analytics',
          onAccept: () => {
            console.log('Analytics consent given – enabling GA');
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'G-JRR2DJWD1R');
          },
          onReject: () => {
            console.log('Analytics consent withdrawn – removing GA cookies');
          },
        },
      },
    },
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'This website uses cookies',
          description: 'We use cookies on our site to improve your experience and analyse usage.',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Let me choose',
          footer: `
                <a href="/cookie-policy">Cookie Policy</a>
                <a href="/privacy-policy">Privacy Policy</a>
              `,
        },
        preferencesModal: {
          title: 'Manage cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Accept current selection',
          closeIconLabel: 'Close',
          sections: [
            {
              title: 'Your Privacy Choices',
              description: `In this panel you can express some preferences related to cookies used on this website. You may review and change expressed choices at any time by resurfacing this panel via the link in the footer. To deny your consent to the specific processing activities described below, switch the toggles to off or use the “Reject all” button and confirm you want to save your choices.`,
            },
            {
              title: 'Strictly Necessary',
              description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
              linkedCategory: 'necessary',
              cookieTable: {
                headers: {
                  name: 'Cookie',
                  domain: 'Domain',
                  expires: 'Expiration',
                  desc: 'Description'
                },
                body: [
                  {
                    name: 'cc_cookie',
                    domain: location.hostname,
                    expires: '182 days',
                    desc: 'Remembers your cookie preferences.',
                  },
                  {
                    name: 'CraftSessionId',
                    domain: location.hostname,
                    expires: 'Session',
                    desc: 'Persists session state.',
                  },
                  {
                    name: 'CRAFT_CSRF_TOKEN',
                    domain: location.hostname,
                    expires: 'Session',
                    desc: 'Protexts against CSFR attacks.',
                  },
                  {
                    name: '*_identity',
                    domain: location.hostname,
                    expires: 'While logged in',
                    desc: 'Maintains a secure, authenticated session.',
                  },
                  {
                    name: '*_username',
                    domain: location.hostname,
                    expires: '1 year',
                    desc: 'Remembers your username when logging in.',
                  }
                ]
              }
            },
            {
              title: 'Embedded Content',
              description: 'Our site contains some video content. We embed videos from Vimeo and Youtube, using Do Not Track and privacy-enhanced modes. These remaining cookies are necessary to display the videos.',
              linkedCategory: 'necessary',
              cookieTable: {
                headers: {
                  name: 'Cookie',
                  domain: 'Domain',
                  expires: 'Expiration',
                  desc: 'Description'
                },
                body: [
                  {
                    name: 'player_clearance',
                    domain: 'vimeo.com',
                    expires: '7 days',
                    desc: 'Vimeo cookie used for bot prevention.',
                  },
                  {
                    name: 'cf_clearance',
                    domain: 'vimeo.com',
                    expires: '1 year',
                    desc: 'Cloudflare cookie used for bot prevention.',
                  },
                  {
                    name: '_cf_bm',
                    domain: 'vimeo.com',
                    expires: '30 minutes',
                    desc: 'Cloudflare bot manager, manages incoming traffic that matches criteria associated with bots.',
                  },
                  {
                    name: 'AEC',
                    domain: 'youtube.com',
                    expires: '6 months',
                    desc: 'Detect spam, fraud, and abuse.',
                  },
                  {
                    name: 'SOCS',
                    domain: 'youtube.com',
                    expires: '13 months',
                    desc: 'Store a user’s state regarding their cookies choices.',
                  },
                  {
                    name: '_Secure-ENID',
                    domain: 'youtube.com',
                    expires: '13 months',
                    desc: 'Detect spam, fraud, and abuse.',
                  }
                ]
              }
            },
            {
              title: 'Performance and Analytics',
              description: 'These cookies collect information about how you use our website. All of the data is anonymised and cannot be used to identify you.',
              linkedCategory: 'analytics',
              cookieTable: {
                headers: {
                  name: 'Cookie',
                  domain: 'Domain',
                  expires: 'Expiration',
                  desc: 'Description'
                },
                body: [
                  {
                    name: '_ga',
                    domain: 'google.com',
                    expires: '2 years',
                    desc: 'Used by Google Analytics to distinguish users.',
                  },
                  {
                    name: '_gid',
                    domain: 'google.com',
                    expires: '2 years',
                    desc: 'Used by Google Analytics to persist session state.',
                  }
                ]
              }
            },
            {
              title: 'More information',
              description: 'For any queries in relation to these cookies and your choices, please <a href="/contact-us">contact us</a>'
            }
          ]
        },
      },
    },
  },
});